module.exports = __webpack_public_path__ + "static/media/webdesign-services-img3.16cd1d90.jpg";